import React from 'react'
import { useParamsInt } from '../../../../../shared/hooks/location'
import { useRouteMatch } from 'react-router-dom'
import { useApiListAnalyticTopic } from '../../../../../api-new/state/analytics'
import { Menu, MenuAdd, MenuDelete, MenuEdit, MenuRecycle } from '../../../../../shared/menu/menu'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../shared/card/card-full-height-scroll-y'
import { TableAgClient } from '../../../../../shared/table-builder/table-ag-client'
import { ColumnMenu, ColumnText } from '../../../../../shared/table-builder/table-columns'
import { IconList } from '../../../../../shared/icon/icon'
import { useRoleOrgAnalytic } from '../../../../../role/hook/role-org'

export const AnalyticCourseTopicList = () => {
  const { url } = useRouteMatch()
  const { nodeID } = useParamsInt()

  const apiListAnalyticTopic = useApiListAnalyticTopic()

  const roleOrgAnalytic = useRoleOrgAnalytic()

  const handleReady = () => apiListAnalyticTopic.get(`${nodeID}/node`)
  const handleDestroyed = () => apiListAnalyticTopic.init()

  const handleDelete = async data => {
    await apiListAnalyticTopic.delete(data.id)
    await apiListAnalyticTopic.get(`${nodeID}/node`)
  }

  const HeaderMenu = () =>
    <Menu>
      <MenuAdd to={`${url}/add`} show={roleOrgAnalytic.accessCreate} />
      <MenuRecycle to={`${url}/recycle`} show={roleOrgAnalytic.accessDelete} />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="Topics">
        <CardFullHeightScrollY title="Topics" HeaderMenu={HeaderMenu}>
          <TableAgClient apiList={apiListAnalyticTopic} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="name" />
            <ColumnText field="description" />
            <ColumnText field="analyticCount" header="Analytics" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuEdit to={`${url}/${row.id}/edit`} show={roleOrgAnalytic.accessRead} />
                  <MenuDelete onClick={() => handleDelete(row)} show={roleOrgAnalytic.accessDelete} />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
